import { ReportsReducerState } from './types';

export const initialState: ReportsReducerState = {
  filters: {
    order: 'asc',
    orderBy: 'date',
    query: '',
  },
};
